import { render, staticRenderFns } from "./ninjaProducts.vue?vue&type=template&id=7733084e&"
import script from "./ninjaProducts.vue?vue&type=script&lang=js&"
export * from "./ninjaProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports